import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import VideoThumbnailCard from '../../../../v2/components/VideoThumbnailCard';
import TRC_CONTENT from '@/constants/trcContentType';

const VideoGrid = ({ trcVideos, isLoggedIn }) => {
	return (
		<div className="c-video_list">
			<div className="row m-0">
				{trcVideos?.map(video => (
					<div key={video._id || video.title} className="mb-2">
						<VideoThumbnailCard
							content={video}
							isLoggedIn={isLoggedIn}
							titleStyles={{ fontSize: 'clamp(1.15rem, 1.2vw, 1.6rem)' }}
							showAddToPlaylist={false}
							showSaveButton={false}
							route={TRC_ROUTES.VIDEOS.toLowerCase()}
							type={TRC_CONTENT.TRC}
							customStyles={{ width: '100%', aspectRatio: '16/9' }}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default VideoGrid;
